import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AgendaModif from './agendaModif';
import AgendaAffichageInfo from './agendaAffichageInfo';
import moment from 'moment';
import { Alert } from 'react-bootstrap';
import 'moment/locale/fr';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import frLocale from '@fullcalendar/core/locales/fr';
import timeGridPlugin from '@fullcalendar/timegrid';






function AgendaAffichage(props) {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [evenement, setEvenement] = useState(null);
  const [modification, setModification] = useState(false);
  const [eventmodif, setEventmodif] = useState(null);
  const [success, setSuccess] = useState(false);
  const [affichage, setAffichage] = useState(false);
  const [info, setInfo] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/agenda/affichage/equipe/${props.userData.user.donnée.results[0].id_equipe}`,
          {
            withCredentials: true
          }
        );
        setError(null);
        setIsLoading(false);
        const agendaMatch = response.data.match.map(item => ({
          title: item.equipe_dom + " vs " + item.equipe_ext,
          start: modificationDateMatch(item.date),
          end: modificationDateMatch(item.date, true),
          color: 'rgba(0, 230, 118, 1)',
          defId : item.id_match,
          className: 'color-1',
          
        }));
        
        const agendaEvenement = response.data.evenements.map(item => ({
          title: item.sujet + ", " + item.localisation,
          start: modifDateEvent(item.date_debut + " , " + item.heure_debut),
          end: modifDateEvent(item.date_fin + " , " + item.heure_fin),
          color: item.couleur,
          className: item.couleur,
          defId : item.id_evenement
        }));

        const tournois = response.data.tournois.map(item => ({
          title: "Tournoi : " + item.nomTournois + ", " + item.localisation,
          start: modifDateEvent(item.date + " , 08:00"),
          end: modifDateEvent(item.date + " , 17:00"),
          color: 'rgba(30, 0, 244, 0.8)',
          defId : item.id_tournoi,
          className: 'color-4',
        }));

        const agenda = [...agendaMatch, ...agendaEvenement, ...tournois];
        setEvenement(agenda);
      } catch (error) {
        if (error.response) {
          setError(error.response.data.message);
        } else {
          console.log(error);
          setError(true);
        }
        setIsLoading(false);
      }
    };
    fetchData();
  }, [apiUrl, props.userData]);

  const modificationDateMatch = (dateString, adjustEndTime = false) => {
    const parts = dateString.split(' - ');
    const datePart = parts[0];
    const timePart = parts[1];
    const [, dayOfMonth, month] = datePart.split(' ');

    const months = {
      'janvier': 0, 'février': 1, 'mars': 2, 'avril': 3,
      'mai': 4, 'juin': 5, 'juillet': 6, 'août': 7,
      'septembre': 8, 'octobre': 9, 'novembre': 10, 'décembre': 11
    };

    const year = new Date().getFullYear();
    const monthIndex = months[month.toLowerCase()];

    const date = new Date(year, monthIndex, parseInt(dayOfMonth, 10));
    const [hour, minute] = timePart.split(':');

    date.setHours(parseInt(hour, 10));
    date.setMinutes(parseInt(minute, 10));

    if (adjustEndTime) {
      date.setHours(date.getHours() + 1);
      date.setMinutes(date.getMinutes() + 45);
    }

    return date;
  };

  const modifDateEvent = (dateString) => {
    const [datePart, timePart] = dateString.split(' , ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes] = timePart.split(':').map(Number);

    return new Date(year, month - 1, day, hours, minutes);
  };

  const modifEvent = (item) => {
    const eventBackgroundColor = item.event._def.ui.backgroundColor;
    const debut_date = moment(item.event.start).format('YYYY-MM-DD');
    const debut_heure = moment(item.event.start).format('HH:mm');
    const fin_date = moment(item.event.end).format('YYYY-MM-DD');
    const fin_heure = moment(item.event.end).format('HH:mm');
    const id = item.event.extendedProps.defId; 
    const event = [item.event, debut_date, debut_heure, fin_heure, fin_date,id ];
    if (eventBackgroundColor !== "rgba(0, 230, 118, 1)" && eventBackgroundColor !== "rgba(30, 0, 244, 0.8)") { 
      setEventmodif(event);
      setModification(true);
    } 
    else {
      setInfo(event);
      setAffichage(true);
    }
  };


  const infoEvent = (item) => {
    const debut_date = moment(item.event.start).format('YYYY-MM-DD');
    const debut_heure = moment(item.event.start).format('HH:mm');
    const fin_date = moment(item.event.end).format('YYYY-MM-DD');
    const fin_heure = moment(item.event.end).format('HH:mm');
    const id = item.event.extendedProps.defId; 
    const event = [item.event, debut_date, debut_heure, fin_heure, fin_date,id]
      setInfo(event);
      setAffichage(true);

  };



  if (isLoading) {
    return (
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    
    );  
  }
  return (
    <>
      <div>
        {affichage && (
          <AgendaAffichageInfo
            show={affichage}
            quit={() => { setAffichage(false); setInfo(null); }}
            info={info}
          />
        )}
        {modification && (
          <AgendaModif
            show={modification}
            quit={() => { setModification(false); setEventmodif(null); }}
            eventmodif={eventmodif}
            success={() =>{setSuccess(true);setTimeout(() => {setSuccess(false);window.location.reload();}, 10000);}}
            userData={props.userData}
          />
        )}
        {error && 
          <div id="alert-message" className="alert4" style={{ fontSize: "15px" }}>
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
          </div>
        }
        {success &&(
          <Alert key="success" variant="success" style={{ fontSize: "15px", margin: "auto", width: "80%" }}>
              Félicitations ! L'événement a été modifié avec succès.
           </Alert>
        )}
        {evenement && (
          <>
            {props.userData.user.type === "coach" ? (
              <>
                <FullCalendar
                  plugins={[dayGridPlugin, timeGridPlugin]}
                  headerToolbar={{
                    left : 'prev,next today',
                    center : 'title',
                    right : 'dayGridMonth,timeGridWeek,timeGridDay'
                  }}
                  initialView="dayGridMonth"
                  events={evenement} 
                  eventClick={modifEvent} 
                  locales={[frLocale]}
                  themeSystem="bootstrap"
                  height="auto" 
                  weekNumbers={true} 
                  dayMaxEventRows={3} 
                  eventContent={(arg, createElement) => {
                    return (
                      <>
                        <div><strong>{arg.timeText}: {arg.event.title}</strong></div>
                      </>
                    );
                  }}
                  
                />

              </>
            ):(
              <>
              <FullCalendar
                plugins={[dayGridPlugin, timeGridPlugin]}
                headerToolbar={{
                  left : 'prev,next today',
                  center : 'title',
                  right : 'dayGridMonth,timeGridWeek,timeGridDay'
                }}
                initialView="dayGridMonth"
                events={evenement} 
                eventClick={infoEvent} 
                locales={[frLocale]}
                themeSystem="bootstrap"
                weekNumbers={true} 
                fixedWeekCount={3} 
                height="auto"
                dayMaxEventRows={3} 
                eventContent={(arg, createElement) => {
                  return (
                    <>
                      <div><strong>{arg.timeText}: {arg.event.title}</strong></div>
                    </>
                  );
                }}
              />

              </>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default AgendaAffichage;
